export enum Step {
  Phone,
  Code,
  Email,
  Done,
}

/** Steps the progress bar counts, so Done is excluded. */
export const TotalSteps = 3

// Each step owns a URL so the browser back button moves between them
const Paths: Record<Step, string> = {
  [Step.Phone]: "/",
  [Step.Code]: "/verify",
  [Step.Email]: "/email",
  [Step.Done]: "/done",
}

export const StepSegments = Object.values(Paths)
  .map((path) => path.slice(1))
  .filter(Boolean)

// The invite code travels with every step so the member can forward the link
// from wherever they are and have it still credit the referrer.
export function pathForStep(step: Step, referCode?: string) {
  const path = Paths[step]
  return referCode ? `${path}?ref=${encodeURIComponent(referCode)}` : path
}

export function stepFromPath(pathname: string): Step | null {
  switch (pathname.split("/")[1] || "") {
    case "":
      return Step.Phone
    case "verify":
      return Step.Code
    case "email":
      return Step.Email
    case "done":
      return Step.Done
    default:
      return null
  }
}
